import * as tf from '@tensorflow/tfjs'
import { KNeighborsRegressor, setBackend } from '@/vendor/scikitjs/dist/es5'
import $ from "jquery";
import { generateUniqueId } from "@/assets/js/Utilities";

export default class AIMagicMode {
	constructor(controls) {
		setBackend(tf)

		this.blockName = 'AIMagicMode';
		this.templateName = 'ai-magic-mode';
		this.version = '1.0.0';

		this.img_size = 64
		this.lut_size = 8

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
		this.controls = controls;
		this.models = [
			{
				name: 'AI Exposure',
				file: null
			},
			{
				name: 'AI Contrast',
				file: null
			},
			{
				name: 'AI White Balance',
				file: null
			}
		]
	}

	async addBlock(blockNum = lutify.blocks.length, data = false) {
		this.controls.forEach(controlData => (controlData.control = controlData.name));
		UI.createAdjustmentBlockTemplate(this.templateName, blockNum, data);
		let $element = $(UI.getAdjustmentBlock(blockNum));

		UI.removeBlockBlendingModes($element);

		lutify.AIMagicMode.isApplied = true;

		UI.appendBlockLoadingSpinner($element);
		lutPreviewer.showPlaceholderPreviews();

		await this.loadModels();

		this.addControls($element);

		if (data) this.removeNav(); // coming from loading a preset/candidate
		this.createNavSteps();
		this.createNavLabel();

		$element.find(".lut-selector__items-container").hide();

		$element.on("click", e => {
			e.stopImmediatePropagation();

			if (!vm.$store.getters['User/isGuest']) {
				$("#magic-mode-nav-label").removeClass("hide");
				$("#magic-mode-nav-container").removeClass("hide");
			}

			if (lutify.AIMagicMode.activeStep) {
				lutify.selectedPreviewCategory = this.controls[lutify.AIMagicMode.activeStep].category;

				let controlName = this.controls[lutify.AIMagicMode.activeStep].name;
				let controlCategory = this.controls[lutify.AIMagicMode.activeStep].category;

				if (controlName == 'LUTcontrols') {
					if (luts.loaded[controlName].controls[controlCategory].status == "loaded") {
						this.showPreviews(lutify.AIMagicMode.activeStep);
					} else {
						UI.togglePreviewsContainer();
						lutPreviewer.showPlaceholderPreviews();
					}
				} else {
					// AI Predicted Previews
					if (lutify.getActiveBlock().predictions[lutify.AIMagicMode.activeStep]) {
						this.showAIPredictionPreviews(lutify.AIMagicMode.activeStep);
					} else {
						UI.togglePreviewsContainer();
						lutPreviewer.showPlaceholderPreviews();
					}
				}
			}
		});

		$element.find(".btn-remove-block").on("click", _ => this.removeMagicMode());
		$element.find(".btn-reset-block").off("click").on("click", e => this.resetBlock($element, e));
		$element.find(".btn-reset-selection").on("click", e => this.removeSelection(e));

		$element.find(".lut-selector__label-container").on("click", e => this.toggleControlSelector($(e.currentTarget)));

		blocks.add({
			name: this.blockName,
			// control: data.control,
			passes: this.addPasses(),
			predictions: [],
			predictionsContent: [],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			selectedPreview: this.controls.map(() => null),
			selectedPreviewName: this.controls.map(() => null),
			opacity: this.controls.map(control => {
				if (['AI Exposure', 'AI Contrast', 'AI White Balance'].includes(control.category)) return 50;
				else return 100;
			}),
		});

		// coming from loading a preset/candidate
		if (data?.waitToLoad) await this.loadAllControlLuts("waitToLoad");
		else {
			$element.find(".expand_options").trigger("click", [false]);
			$element.find(".magic-mode-controls-container i").eq(0).trigger("click");
			this.loadAllControlLuts();
			UI.removeBlockLoadingSpinner($element);
		}

		UI.scrollToBlock(blockNum);
		UI.attachTemporaryLUTSelectionHandler();

		$element.find('.controls-wrapper .switch input').trigger('click')
	}

	addControls($element) {
		this.controls.forEach((controlData, i) => {
			let item = document.createElement("i");
			item.setAttribute("data-name", controlData.name);
			item.setAttribute("data-category", controlData.category);
			item.setAttribute("data-step", i);
			item.setAttribute("data-tippy-content", controlData.label);
			item.setAttribute("class", "material-icons");
			if (i == 0) item.setAttribute("class", "material-icons --selected");
			item.innerHTML = controlData.icon;
			item.addEventListener("click", e => {
				e.stopPropagation();
				this.controlClickEvent(e.currentTarget);
			});
			$element.find(".magic-mode-controls-container").append(item);
		});
	}

	createNavSteps() {
		if ($("#magic-mode-nav-container").length > 0) return;

		let container = document.createElement("div");
		container.setAttribute("id", "magic-mode-nav-container");
		if (vm.$store.getters['User/isGuest']) container.setAttribute("class", "hide");
		// let arrowLeft = '<i id="magic-mode-prev-btn" data-action="prev" class="material-icons nav-btn">keyboard_arrow_left</i>';
		// let arrowRight = '<i id="magic-mode-next-btn" data-action="next" class="material-icons nav-btn">keyboard_arrow_right</i>';

		this.controls.forEach((controlData, i) => {
			let item = document.createElement("i");
			item.setAttribute("data-name", controlData.name);
			item.setAttribute("data-category", controlData.category);
			item.setAttribute("data-step", i);
			item.setAttribute("data-tippy-content", controlData.label);
			item.setAttribute("class", "material-icons nav-step");
			item.innerHTML = controlData.icon;
			if (i == 0) item.setAttribute("class", "material-icons nav-step --selected");
			container.appendChild(item);
		});

		$("#wrapper #content").append(container);
		// $('#magic-mode-nav-container').prepend(arrowLeft);
		// $('#magic-mode-nav-container').append(arrowRight);

		$("#magic-mode-nav-container .nav-step").on("click", (e, triggerChange) => {
			e.stopPropagation();
			this.navClickEvent(e.currentTarget, triggerChange);
		});
		// $('#magic-mode-prev-btn').on('click', e => this.navArrowHandler(e.currentTarget));
		// $('#magic-mode-next-btn').on('click', e => this.navArrowHandler(e.currentTarget));
	}

	createNavLabel() {
		let label = document.createElement("span");
		label.setAttribute("id", "magic-mode-nav-label");
		if (vm.$store.getters['User/isGuest']) label.setAttribute("class", "hide");
		$("#wrapper #content").prepend(label);
	}

	updateNavLabel() {
		$("#magic-mode-nav-label").html(this.controls[lutify.AIMagicMode.activeStep].label);
	}

	navArrowHandler(action = "next") {
		let gotoStep;
		action == "next" ? (gotoStep = parseInt(lutify.AIMagicMode.activeStep) + 1) : (gotoStep = parseInt(lutify.AIMagicMode.activeStep) - 1);
		$(`#magic-mode-nav-container .nav-step[data-step="${gotoStep}"]`).trigger("click");
	}

	toggleControlSelector($el) {
		let itemsContainer = $el.siblings(".lut-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	async controlClickEvent(control) {
		lutify.AIMagicMode.activeStep = control.dataset.step;
		$(".magic-mode-controls-container i").removeClass("--selected");
		control.classList.add("--selected");
		$(`#magic-mode-nav-container .nav-step[data-step="${control.dataset.step}"]`).trigger("click", [false]);
		lutify.selectedPreviewCategory = this.controls[lutify.AIMagicMode.activeStep].category;

		// this.toggleNavArrows();
		this.updateLabel();
		this.updateNavLabel();

		if (control.dataset.name == 'LUTcontrols') {
			if (luts.loaded[control.dataset.name].controls[control.dataset.category].status == "loaded") {
				this.showPreviews(control.dataset.step);
				this.updateLutsDropdownList();
				this.enableLutDropdown();
			} else {
				this.disableLutDropdown();
				lutPreviewer.showPlaceholderPreviews();
				UI.updatePreviewsTab();
			}
		} else {
			// AI Predicted Previews
			if (lutify.getActiveBlock().predictions[lutify.AIMagicMode.activeStep]) {
				this.showAIPredictionPreviews(lutify.AIMagicMode.activeStep);
				this.updateLutsDropdownList();
				this.enableLutDropdown();
			} else {
				this.disableLutDropdown();
				lutPreviewer.showPlaceholderPreviews();
				UI.updatePreviewsTab();

				await this.predict(this.models[lutify.AIMagicMode.activeStep]);

				lutPreviewer.removePlaceholderPreviews();
				this.updateLutsDropdownList();
				this.enableLutDropdown();

				this.showAIPredictionPreviews(lutify.AIMagicMode.activeStep);
			}
		}
	}

	navClickEvent(control, triggerChange = true) {
		vm.$store.dispatch('UI/setShowLutPreviews', true);
		vm.$nextTick(() => {
			if (window.lutify.getActiveBlock()) window.UI.getActiveBlock().click();
		})

		$("#magic-mode-nav-container .nav-step").removeClass("--selected");
		$(control).addClass("--selected");

		if (triggerChange) $(`.magic-mode-controls-container i[data-step="${control.dataset.step}"]`).trigger("click");
	}

	enableLutDropdown() {
		UI.getActiveBlock()
			.find(".lut-selector")
			.removeClass("--disabled");
		UI.getActiveBlock()
			.find(".block-sliders-container")
			.removeClass("--disabled");
	}

	disableLutDropdown() {
		UI.getActiveBlock()
			.find(".lut-selector")
			.addClass("--disabled");
		UI.getActiveBlock()
			.find(".block-sliders-container")
			.addClass("--disabled");
	}

	updateLabel() {
		if (lutify.getActiveBlock().selectedPreview[lutify.AIMagicMode.activeStep] !== null) {
			// let lutName = UI.getPreviewDescription(lutify.getActiveBlock().selectedPreview[lutify.AIMagicMode.activeStep]);
			let lutName = lutify.getActiveBlock().selectedPreviewName[lutify.AIMagicMode.activeStep];
			UI.getActiveBlock()
				.find(".selected-lut-name")
				.html("Look: " + lutName);
		} else {
			UI.getActiveBlock()
				.find(".selected-lut-name")
				.html("Select...");
		}
	}

	updateLutsDropdownList() {
		const selectedControl = this.controls[lutify.AIMagicMode.activeStep];
		let selectedLuts = [];

		if (selectedControl.name == 'LUTcontrols') {
			selectedLuts = luts[selectedControl.control][selectedControl.category];
		} else {
			selectedLuts = lutify.getActiveBlock().predictions[lutify.AIMagicMode.activeStep];
		}

		let lutsList = UI.createLutDropdownList(selectedLuts);
		UI.getActiveBlock()
			.find(".lut-selector__items-container")
			.html("");
		UI.getActiveBlock()
			.find(".lut-selector__items-container")
			.html(lutsList);
		UI.getActiveBlock()
			.find(".lut-selector__items-container > span")
			.on("click", e => this.lutDropdownSelection(e.currentTarget));
	}

	lutDropdownSelection(selectedLut) {
		let $blockOptions = $(selectedLut).closest(".block_options");
		$blockOptions.find(".lut-selector__items-container").hide();
		this.updateLabel();
		$(`#previews-list-container > .list-item[data-composer-index="${selectedLut.dataset.composerIndex}"]`).trigger("click");
	}

	async loadModels(toolName = this.blockName) {
		if (this.models.some(model => model.file)) return
		if (vm.$store.state.UI.AIMagicMode.isDownloading) return;

		let storeData = await this.isModelDownloaded()

		if (!storeData) {
			vm.$store.dispatch('UI/setAIMagicModeDownloading', true);

			let response = await vm.$store.dispatch('Projects/fetchSystemFiles', {
				block: this.templateName
			})

			let progress = []
			let promises = []

			response.forEach((file, idx) => {
				promises.push(
					vm.$store.dispatch('Files/fetchFromS3', {
						url: file.presignedURL,
						config: {
							responseType: 'blob',
							onDownloadProgress: progressEvent => {
								progress[idx] = Math.round((progressEvent.loaded * 100) / progressEvent.total)
							}
						}
					})
				)
			})

			let interval = setInterval(async () => {
				if (!progress.length) return
				let totalProgress = progress.reduce((r, i) => (r + i)) / promises.length

				if (totalProgress >= 100) {
					clearInterval(interval)
					// vm.$snackbar(`AI model downloaded. You may now use the ${toolName} tool.`, 'success');
				}

				vm.$store.dispatch('UI/setAIMagicModeDownloadProgress', totalProgress.toFixed())
			}, 50)

			let files = await Promise.all(promises)

			storeData = {
				AIExposure: {
					model: new File([files[0]], response[0].name),
					weights: [
						new File([files[1]], response[1].name),
						new File([files[2]], response[2].name),
					]
				},
				AIContrast: {
					model: new File([files[3]], response[3].name),
					weights: [
						new File([files[4]], response[4].name),
						new File([files[5]], response[5].name),
					]
				},
				AIWhiteBalance: {
					model: new File([files[6]], response[6].name),
					weights: [
						new File([files[7]], response[7].name),
						new File([files[8]], response[8].name),
					]
				},
			}

			vm.$store.dispatch('UI/setAIMagicModeDownloading', false)
			await window.blocksStore.setItem(this.blockName, storeData)
		}

		this.models[0].file = await tf.loadLayersModel(
			tf.io.browserFiles([
				storeData.AIExposure.model,
				storeData.AIExposure.weights[0],
				storeData.AIExposure.weights[1]
			])
		)

		this.models[1].file = await tf.loadLayersModel(
			tf.io.browserFiles([
				storeData.AIContrast.model,
				storeData.AIContrast.weights[0],
				storeData.AIContrast.weights[1]
			])
		)

		this.models[2].file = await tf.loadLayersModel(
			tf.io.browserFiles([
				storeData.AIWhiteBalance.model,
				storeData.AIWhiteBalance.weights[0],
				storeData.AIWhiteBalance.weights[1]
			])
		)
	}

	async isModelDownloaded() {
		let storeData = await window.blocksStore.getItem(this.blockName)
		return storeData
	}

	async predict(model) {
		const imageElement = await this.getImage(model);

		const { lutFile, lutContent } = await this.predictLutFromModel(model.file, imageElement);
		await this.createAIPredictedPreviews(lutFile, lutContent, model);
	}

	async createAIPredictedPreviews(lutFile, lutContent, model) {
		const targetModelIndex = this.models.indexOf(model);
		lutFile.control = this.blockName;
		lutFile.category = `${model.name}-${lutify.getActiveBlock().passes[targetModelIndex].uid}`;

		// const loadedLutsList = [
		// 	{
		// 		...lutFile,
		// 		title: `${model.name} 1`,
		// 		opacity: 25
		// 	},
		// 	{
		// 		...lutFile,
		// 		title: `${model.name} 2`,
		// 		opacity: 50
		// 	},
		// 	{
		// 		...lutFile,
		// 		title: `${model.name} 3`,
		// 		opacity: 75
		// 	},
		// 	{
		// 		...lutFile,
		// 		title: `${model.name} 4`,
		// 		opacity: 100
		// 	},
		// ];

		const loadedLutsList = [
			{
				...lutFile,
				title: `${model.name}`,
				opacity: 50
			},
		];

		lutify.getActiveBlock().predictions[targetModelIndex] = loadedLutsList;
		lutify.getActiveBlock().predictionsContent[targetModelIndex] = lutContent;

		lutPreviewer.createPreviews(loadedLutsList, false, null, this.blockName);
	}

	async predictLutFromModel(model, imageElement) {
		let tensor = tf.browser.fromPixels(imageElement)

		tensor = tf.cast(tensor, 'float32')
		tensor = this.resize(tensor, this.img_size)
		let image = this.normalize(tensor)

		let image_reshaped = tf.reshape(image, [1, this.img_size, this.img_size, 3])
		let target = await model.apply(image_reshaped, { 'training': true })
		let LUT = await this.img_to_lut(image, tf.squeeze(target))
		let [r, g, b] = this.split_channels(LUT, 3, 1)

		let text = `TITLE Created with fylm.ai ${this.blockName}\n`
		text = text + 'LUT_3D_SIZE 8\n\n'
		for (let i = 0; i < this.lut_size * this.lut_size * this.lut_size; i++) {
			text = text + r[i].toFixed(6).toString() + ' ' + g[i].toFixed(6).toString() + ' ' + b[i].toFixed(6).toString() + '\n'
		}

		let LUTFile = new File([text], `${this.templateName}.cube`, { type: 'text/plain' })
		let loadedLUTs = await luts.load([LUTFile])
		return {
			lutFile: loadedLUTs[0],
			lutContent: text
		}
	}

	async getImage(model) {
		let targetPassIndex = this.models.indexOf(model);
		let passes = blocks.getAllPassesToPass(lutify.getActiveBlock().passes[targetPassIndex].uid);

		// check the image size for when using larged media sizes
		let imageURL = lutify.getIDTLMTimage(passes) // getting the main canvas image with IDT LMT

		let imageElement = new Image()
		imageElement.src = imageURL
		await imageElement.decode()
		return imageElement
	}

	resize(input_image, size) {
		let output_image = tf.image.resizeNearestNeighbor(input_image, [size, size])
		return output_image
	}

	normalize(input_image) {
		let output_image = tf.sub(tf.div(input_image, 127.5), 1)
		return output_image
	}

	async img_to_lut(input_image, target_image) {
		let target = tf.add(tf.mul(target_image, 0.5), 0.5)
		let input = tf.add(tf.mul(input_image, 0.5), 0.5)

		let t = tf.sub(target, input)
		let [tR, tG, tB] = this.split_channels(t, 3, 2)

		let [iR, iG, iB] = this.split_channels(input, 3, 2)
		let icolor = tf.stack([iR, iG, iB]).transpose()

		let a = this.lut_size - 1
		let LUT = []
		for (let k = 0; k < this.lut_size; k++) {
			for (let j = 0; j < this.lut_size; j++) {
				for (let i = 0; i < this.lut_size; i++) {
					LUT.push([i / a, j / a, k / a])
				}
			}
		}

		LUT = tf.stack(LUT)

		let interpolation = new KNeighborsRegressor(40, 'distance')
		await interpolation.fit(icolor, tR)
		let tRp = interpolation.predict(LUT)

		await interpolation.fit(icolor, tG)
		let tGp = interpolation.predict(LUT)

		await interpolation.fit(icolor, tB)
		let tBp = interpolation.predict(LUT)

		let [lutiR, lutiG, lutiB] = this.split_channels(LUT, 3, 1)
		lutiR = tf.add(lutiR, tRp)
		lutiG = tf.add(lutiG, tGp)
		lutiB = tf.add(lutiB, tBp)
		LUT = tf.stack([lutiR, lutiG, lutiB]).transpose()

		LUT = await tf.clipByValue(LUT, 0, 1)
		return LUT
	}

	split_channels(tensor, num_splits, axis) {
		let [tR, tG, tB] = tf.split(tensor, num_splits, axis)
		tR = tR.dataSync()
		tG = tG.dataSync()
		tB = tB.dataSync()
		return [tR, tG, tB]
	}

	async loadControlLuts(data, showPreviewsAfterLoad = true) {
		if (typeof luts.loaded[data.control].controls[data.category] == "undefined") {
			luts.loaded[data.control].controls[data.category] = { status: "idle", total: null, fetched: null };
			luts[data.control][data.category] = [];
		}

		// When all luts fetched, don't fetch again.
		if (luts.loaded[data.control].controls[data.category].status == "loaded") return;

		if (luts.loaded[data.control].controls[data.category].status == "idle") {
			luts.loaded[data.control].controls[data.category].status = "loading";

			let fetchedLUTs = await luts.fetchLUTcontrols(data);
			await luts.load(fetchedLUTs, luts[data.control][data.category]);

			luts[data.control][data.category].forEach((LUT, key) => {
				LUT.control = data.control;
				LUT.category = data.category;
				LUT.lutId = key + 1;
			});

			luts.loaded[data.control].controls[data.category].fetched += fetchedLUTs.length;

			lutPreviewer.createPreviews(luts[data.control][data.category]);
			luts.loaded[data.control].controls[data.category].status = "loaded";
		}

		// If we add more of the same block while the initial is being in 'loading'
		else if (luts.loaded[data.control].controls[data.category].status == "loading") {
			return await new Promise(resolve => {
				let interval = setInterval(_ => {
					if (luts.loaded[data.control].controls[data.category].status == "loaded") {
						clearInterval(interval);
						resolve();
					}
				}, 500);
			});
		}

		if (lutify.getActiveBlock() && lutify.getActiveBlock().name == this.blockName && showPreviewsAfterLoad) {
			if (this.controls[lutify.AIMagicMode.activeStep].category == data.category) {
				this.showPreviews(lutify.AIMagicMode.activeStep);
				this.updateLutsDropdownList();
				this.enableLutDropdown();
			}
		}
	}

	async loadAllControlLuts(waitToLoad = false) {
		const controls = this.controls.filter(control => control.name == 'LUTcontrols');

		// when initially loading the block, don't wait for fetch
		if (!waitToLoad) controls.forEach(controlData => this.loadControlLuts(controlData));
		// when applying preset/candidate, await all fetching/loading
		else {
			for (const [index, controlData] of controls.entries()) {
				await this.loadControlLuts(controlData);
			}
		}
	}

	addPasses() {
		const passes = [];

		this.controls.forEach(control => {
			const renderPass = gpu.createRenderPass();
			gpu.addPassToComposer(renderPass, "toMiddle");
			passes.push(renderPass);
		})

		return passes;
	}

	showPreviews(stepIndex) {
		vm.$store.dispatch('UI/setRegenerateAIBasedPreviewsButton', false);

		UI.togglePreviewsContainer();
		lutPreviewer.switchCanvases(this.controls[stepIndex].category);
		UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview[stepIndex]);

		lutPreviewer.cloneMainComposerPasses();
		lutPreviewer.addPass(this.controls[stepIndex].name, this.controls[stepIndex].category, stepIndex);
		lutPreviewer.render();
	}

	showAIPredictionPreviews(stepIndex = 0) {
		vm.$store.dispatch('UI/setRegenerateAIBasedPreviewsButton', true);

		const category = `${this.controls[stepIndex].category}-${lutify.getActiveBlock().passes[stepIndex].uid}`;

		UI.togglePreviewsContainer();
		lutPreviewer.switchCanvases(category);
		UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview[stepIndex]);

		lutPreviewer.cloneMainComposerPasses();

		this.addPassForAIPredictedPreview(lutify.getActiveBlock().predictions[stepIndex], stepIndex)
		vm.$nextTick(() => lutPreviewer.render());
	}

	addPassForAIPredictedPreview(luts, passIndexToSwap) {
		let passIdToSwap = lutify.getActiveBlock().passes[passIndexToSwap].uid;

		try {
			luts.forEach((lut, i) => {
				let composerIndex = lut.composerIndex;
				let pass = gpu.createLUTPass(lut.texture);
				pass.name = lut.title;
				pass.uid = passIdToSwap;

				if (lut.opacity) {
					pass.uniforms.opacity.value = lut.opacity * 0.01;
				} else {
					pass.uniforms.opacity.value = lutify.getActiveBlock().opacity[lutify.AIMagicMode.activeStep] * 0.01;
				}

				if (pass.uniforms.blendID) {
					pass.uniforms.blendID.value = 0;
				}

				window.lutPreviewer.composers[composerIndex].passes.forEach((composerPass, j) => {
					if (composerPass.uid == passIdToSwap) {
						window.lutPreviewer.composers[composerIndex].removePass(composerPass);
						window.lutPreviewer.composers[composerIndex].addPass(pass, j);
					}
				});
			})
		} catch (error) {
			console.log(error);
		}
	}

	opacitySliderHandler(opacityValue) {
		let calcOpacityValue = opacityValue * 0.01;

		lutify.getActiveBlock().opacity[lutify.AIMagicMode.activeStep] = opacityValue;
		lutify.getActiveBlock().passes[lutify.AIMagicMode.activeStep].uniforms.opacity.value = calcOpacityValue;
		lutify.getActiveBlock().passes[lutify.AIMagicMode.activeStep].enabled = true;

		lutPreviewer.updateOpacity(calcOpacityValue, lutify.AIMagicMode.activeStep);
		UI.setPreviewerOpacity(lutify.getActiveBlock().opacity[lutify.AIMagicMode.activeStep]);

		gpu.render();
		lutPreviewer.render();
	}

	opacityInputHandler(opacityValue) {
		this.opacitySliderHandler(opacityValue)
	}

	resetBlock($element, e) {
		e.stopPropagation();
		$element.find(".opacity-input").val(100);
		$element.find(".opacity-input").trigger("change");

		UI.deselectPreview();
		UI.scrollToSelectedPreview();
		lutify.getActiveBlock().selectedPreview = this.controls.map(() => null);
		lutify.getActiveBlock().selectedPreviewName = this.controls.map(() => null);
		lutify.getActiveBlock().opacity = this.controls.map(control => {
			if (['AI Exposure', 'AI Contrast', 'AI White Balance'].includes(control.category)) return 50;
			else return 100;
		});

		this.controls.forEach((controlData, i) => {
			let renderPass = gpu.createRenderPass();
			renderPass.uid = lutify.getActiveBlock().passes[i].uid;
			let targetPassIndex = gpu.getPassIndexById(lutify.getActiveBlock().passes[i].uid);
			lutify.getActiveBlock().passes[i] = renderPass;
			gpu.composer.passes[targetPassIndex] = lutify.getActiveBlock().passes[i];
		});

		gpu.render();

		$element.find(".magic-mode-controls-container i").removeClass("--applied");
		$("#magic-mode-nav-container .nav-step").removeClass("--applied");
		$("#magic-mode-nav-container .nav-step").eq(0).trigger("click");
	}

	async regeneratePredictions() {
		lutify.getActiveBlock().passes[lutify.AIMagicMode.activeStep].uid = generateUniqueId();

		this.disableLutDropdown();
		lutPreviewer.showPlaceholderPreviews();

		await this.predict(this.models[lutify.AIMagicMode.activeStep]);

		lutPreviewer.removePlaceholderPreviews();
		this.updateLutsDropdownList();
		this.enableLutDropdown();

		lutify.selectedPreviewCategory = this.controls[lutify.AIMagicMode.activeStep].category;
		this.showAIPredictionPreviews(lutify.AIMagicMode.activeStep);

		$(`#previews-list-container .list-item[data-control="${this.blockName}"][data-category="${this.controls[lutify.AIMagicMode.activeStep].category}-${lutify.getActiveBlock().passes[lutify.AIMagicMode.activeStep].uid}"][data-name="${lutify.getActiveBlock().selectedPreviewName[lutify.AIMagicMode.activeStep]}"]`).trigger("click");
		this.opacitySliderHandler(lutify.getActiveBlock().opacity[lutify.AIMagicMode.activeStep]);
	}

	async applyCompare($block, data) {

		for await (const [stepIndex, selectedData] of data.selectedPreviewName.entries()) {
			if (selectedData !== null) {
				lutify.AIMagicMode.activeStep = stepIndex.toString();

				if (this.controls[stepIndex].name == 'LUTcontrols') {
					lutPreviewer.cloneMainComposerPasses();
					lutPreviewer.addPass(this.controls[stepIndex].name, this.controls[stepIndex].category, stepIndex);
					lutPreviewer.render();

					$(`#previews-list-container .list-item[data-control="${this.controls[stepIndex].name}"][data-category="${this.controls[stepIndex].category}"][data-name="${selectedData}"]`).trigger("click");
					// $(`#previews-list-container .list-item[data-control="${this.controls[stepIndex].name}"][data-category="${this.controls[stepIndex].category}"][data-name="${selectedData}"] .range_slider`).val(data.opacity[stepIndex]);
					// $(`#previews-list-container .list-item[data-control="${this.controls[stepIndex].name}"][data-category="${this.controls[stepIndex].category}"][data-name="${selectedData}"] .range_value`).val(data.opacity[stepIndex]);
					this.opacitySliderHandler(data.opacity[stepIndex]);
				} else {
					if (data.predictionsContent[stepIndex]) {
						let LUTFile = new File([data.predictionsContent[stepIndex]], `${this.blockName}.cube`, { type: 'text/plain' })
						let loadedLUTs = await luts.load([LUTFile])

						await this.createAIPredictedPreviews(loadedLUTs[0], data.predictionsContent[stepIndex], this.models[stepIndex]);

						lutPreviewer.cloneMainComposerPasses();
						this.addPassForAIPredictedPreview(lutify.getActiveBlock().predictions[stepIndex], stepIndex)
						lutPreviewer.render();

						$(`#previews-list-container .list-item[data-control="${this.blockName}"][data-category="${this.controls[stepIndex].category}-${lutify.getActiveBlock().passes[stepIndex].uid}"][data-name="${selectedData}"]`).trigger("click");
						// $(`#previews-list-container .list-item[data-control="${this.blockName}"][data-category="${this.controls[stepIndex].category}-${lutify.getActiveBlock().passes[stepIndex].uid}"][data-name="${selectedData}"] .range_slider`).val(data.opacity[stepIndex]);
						// $(`#previews-list-container .list-item[data-control="${this.blockName}"][data-category="${this.controls[stepIndex].category}-${lutify.getActiveBlock().passes[stepIndex].uid}"][data-name="${selectedData}"] .range_value`).val(data.opacity[stepIndex]);
						this.opacitySliderHandler(data.opacity[stepIndex]);
					}
				}
			}
		}

		window.lutify.getActiveBlock().collapsedPreviews = data.collapsedPreviews;

		lutify.AIMagicMode.activeStep = '0';

		if (!lutify.getActiveBlock().predictions[0]) {
			await this.predict(this.models[lutify.AIMagicMode.activeStep]);
		}

		this.updateLabel();
		setTimeout(() => UI.hideMagicModeNav(), 100);
		UI.removeBlockLoadingSpinner($block);

	}

	removeSelection(e) {
		e.stopPropagation();
		lutify.getActiveBlock().selectedPreview[lutify.AIMagicMode.activeStep] = null;
		lutify.getActiveBlock().selectedPreviewName[lutify.AIMagicMode.activeStep] = null;
		lutify.getActiveBlock().passes[lutify.AIMagicMode.activeStep].enabled = false;
		lutify.selectedPreviewCategory = this.controls[lutify.AIMagicMode.activeStep].category;
		gpu.render();

		if (this.controls[lutify.AIMagicMode.activeStep].name == 'LUTcontrols') {
			this.showPreviews(lutify.AIMagicMode.activeStep);
		} else {
			this.showAIPredictionPreviews(lutify.AIMagicMode.activeStep)
		}

		this.resetAppliedTabs();
		this.updateLabel();
	}

	resetAppliedTabs() {
		$(`.magic-mode-controls-container i[data-step="${lutify.AIMagicMode.activeStep}"]`).removeClass("--applied");
		$(`#magic-mode-nav-container i[data-step="${lutify.AIMagicMode.activeStep}"]`).removeClass("--applied");
	}

	removeMagicMode() {
		lutify.AIMagicMode.isApplied = false;
		lutify.AIMagicMode.activeStep = null;
		this.removeNav();
	}

	removeNav() {
		$("#magic-mode-nav-container").remove();
		$("#magic-mode-nav-label").remove();
	}
}
